/**
 * @fileoverview GET handler for the "/engagement/report_builder_2/:report_id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdReportId } from "./constants";
import type { EngagementReportBuilder2AppGroupIdReportId } from "./types";

export const getEngagementReportBuilder2AppGroupIdReportId = reactQueryFetcherAdapter(
  engagementReportBuilder2AppGroupIdReportId,
  (
    signal: AbortSignal,
    reportId: string,
    appGroupId: string
  ): Promise<EngagementReportBuilder2AppGroupIdReportId> => {
    return fetch(`/engagement/report_builder_2/${reportId}/${appGroupId}`, "GET", {}, { signal });
  }
);
